import render from "./mson-react-bootstrap/render";
import compiler from "mson/lib/compiler";
import "typeface-roboto";
import awsConfig from "./aws-exports";

import { Amplify } from "aws-amplify";

import "./lib/app.css";
import form from "./lib/form";
import scan from "./lib/scan";
import mark from "./lib/mark";

const MenuComponent = compiler.newComponent({
  component: "Menu",
  name: "app.Menu",

  items: [
    {
      path: "/search",
      label: "Search",
      content: form,
      fullScreen: true,
      hidden: true,
    },
    {
      path: "/",
      label: "Welcome",
      content: scan,
      fullScreen: true,
      hidden: true,
    },
    {
      path: "/mark",
      label: "Mark Form",
      content: mark,
      fullScreen: true,
      hidden: true,
    },
  ],
});

const App = compiler.newComponent({
  name: "app.App",
  component: "App",
  menu: MenuComponent,
});

Amplify.configure(awsConfig);
// uncomment the next two lines to enble auth
// const out = <AppContainer amplifyConfig={config} component={App} basename="/" />
// ReactDOM.render(App, document.getElementById('root'));
render(App, document.getElementById("root"));
